export const INTERFACE_ORIENTATIONS = {
  PORTRAIT: 'portrait',
  LANDSCAPE: 'landscape',
};

/**
 * Как повернут интерфейс устройства — по данным самой системы, а не по
 * пропорциям окна.
 *
 * CSS-запрос (orientation: ...) про поворот ничего не знает: он лишь
 * сравнивает ширину окна с высотой. Там, где экранная клавиатура отнимает
 * высоту у окна (Chrome и Firefox на iOS, приложение с домашнего экрана
 * iPhone, встроенные браузеры Android), остаток над клавиатурой оказывается
 * шире своей высоты — и запрос отвечает «landscape» на телефоне, который
 * держат вертикально. Системная ориентация от клавиатуры не зависит.
 *
 * @returns {'portrait' | 'landscape' | null} null — браузер ориентацию не сообщает
 */
export const getInterfaceOrientation = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  // Смотрим только на начало строки: какой из двух поворотов primary, а
  // какой secondary, браузеры решают по-разному (Safari 16.4 расходился с
  // Chrome), а нам важно лишь «боком или прямо»
  const orientationType = window.screen?.orientation?.type;
  if (typeof orientationType === 'string') {
    return orientationType.startsWith('landscape')
      ? INTERFACE_ORIENTATIONS.LANDSCAPE
      : INTERFACE_ORIENTATIONS.PORTRAIT;
  }

  // Резерв для iOS до 16.4, где screen.orientation еще нет: угол поворота от
  // естественного положения устройства (у телефона оно вертикальное)
  if (typeof window.orientation === 'number') {
    return Math.abs(window.orientation) === 90
      ? INTERFACE_ORIENTATIONS.LANDSCAPE
      : INTERFACE_ORIENTATIONS.PORTRAIT;
  }

  return null;
};
